<ion-row class="margin-top">
  @for (tenor of availableTenors; track tenor) {
    <ion-col size="4"
             class="ion-text-center"
             [class.center-col]="$count === 1"
             [class.center-col-left]="$count === 2 && $first"
             [class.center-col-right]="$count === 2 && $index === 1">
      <app-tenor-selector [tenor]="tenor"
                          [activeTenor]="activeTenor"
                          (selectTenor)="onTenorSelect($event)" />
    </ion-col>
  }
</ion-row>